import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Button from '../Button';

import './ViewportAttachedButton.scss';

const minKeyboardHeight = 300;

const ViewportAttachedButton = ({
	className = null,
	children = '',
	onClick = () => {},
	disabled = false,
	loading = false,
	...props
}) => {
	const [buttonFitOnBody, setButtonFitOnBody] = useState(false);
	const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

	const sendAmountButtonRef = useRef(null);

	const detectButtonFit = () => {
		setTimeout(() => {
			const prevElement = sendAmountButtonRef.current?.previousElementSibling;
			const amountBodyBottom = prevElement ? prevElement?.getBoundingClientRect().bottom : 0;

			const buttonContainerHeigth = sendAmountButtonRef.current?.clientHeight || 0;

			setButtonFitOnBody(amountBodyBottom > window.innerHeight - buttonContainerHeigth);
		}, 200);
	};

	const checkKeyboardOpen = () => {
		const allScreenHeight = window.screen.height || 0;
		const viewScreenHeight = window.visualViewport.height || 0;
		const isKeyboardOpen = allScreenHeight + minKeyboardHeight < viewScreenHeight;
		setIsKeyboardOpen(isKeyboardOpen);
	};

	const onViewportResize = () => {
		detectButtonFit();
		checkKeyboardOpen();
	};

	useEffect(() => {
		detectButtonFit();
		checkKeyboardOpen();

		document.addEventListener('scroll', detectButtonFit, true);
		window.visualViewport.addEventListener('resize', onViewportResize);

		return () => {
			document.removeEventListener('scroll', detectButtonFit);
			window.visualViewport.removeEventListener('resize', onViewportResize);
		};
	}, []);

	return (
		<div
			className={classNames('ViewportAttachedButton', className, {
				ViewportAttachedButton_compact: isKeyboardOpen,
				ViewportAttachedButton__separator: buttonFitOnBody,
			})}
			ref={sendAmountButtonRef}
		>
			<Button className='SendAmount__continue' onClick={onClick} disabled={disabled} loading={loading} {...props}>
				{children}
			</Button>
		</div>
	);
};

ViewportAttachedButton.propTypes = {
	className: PropTypes.string,
	text: PropTypes.string,
	onClick: PropTypes.func,
	disabled: PropTypes.bool,
	loading: PropTypes.bool,
};

export default ViewportAttachedButton;
